import { DashboardConstants } from '../../actions/constant';

const {
  GET_DASHBOARD_PTO_UPDATE_FAILURE,
  GET_DASHBOARD_PTO_UPDATE_REQUEST,
  GET_DASHBOARD_PTO_UPDATE_LOADER,
  GET_DASHBOARD_PTO_UPDATE_SUCCESS,
} = DashboardConstants;

const intitialstate: object = {
  response: null,
  isPtoUpdates: false,
  loading: false,
};

export const dashboardPtoUpdateReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case GET_DASHBOARD_PTO_UPDATE_SUCCESS: {
      return {
        ...state,
        isPtoUpdates: true,
        response: action.payload?.data,
        loading: false,
      };
    }

    case GET_DASHBOARD_PTO_UPDATE_FAILURE:
      return {
        ...state,
        isPtoUpdates: false,
        response: action.payload,
        loading: false,
      };

    case GET_DASHBOARD_PTO_UPDATE_LOADER:
      return {
        ...state,
        loading: true,
      };

    default:
      return state;
  }
};
